function getMangoCallHash(locale) {
  switch (locale) {
    case 'uk-ua':
      return 'MTAwMDk5Nzg=';
    case 'en-us':
    case 'en-gb':
    case 'en-ie':
      return 'MTAwMDk5Mzk=';
    case 'es':
      return 'MTAwMDk5NzQ=';
    case 'pl':
      return 'MTAwMDk5NzU=';
    case 'de':
      return 'MTAwMDk5NzY=';
    case 'tr':
      return 'MTAwMDk5Nzc=';
    default:
      return null;
  }
}

export default function mangoCall(locale) {
  const mangoAppHash = getMangoCallHash(locale);

  const nextWindow = window.open(
    `https://widgets.mango-office.ru/widget/call-from-site-auto-dial/${mangoAppHash}`,
    'mango',
    'width=238,height=400,resizable=no,toolbar=no,menubar=no,location=no,status=no'
  );

  setTimeout(() => {
    nextWindow.focus();
  }, 500);
}
